import { type ReactNode } from "react";
import { useT } from "./i18n";
import { LangSwitch } from "./components/LangSwitch";

function Hero({ admin }: { admin: boolean }) {
  const { t } = useT();
  return (
    <aside className="hero">
      <div className="hero-grain" aria-hidden />
      <div className="hero-inner">
        <div className="brand-row">
          <span className="logo-dot" aria-hidden />
          <span className="brand-name">Automatrix</span>
        </div>

        <h1 className="hero-title">
          {admin ? (
            <>
              {t("heroAdminA")}
              <em>{t("heroAdminB")}</em>
            </>
          ) : (
            <>
              {t("heroBookA")}
              <em>{t("heroBookB")}</em>
            </>
          )}
        </h1>
        <p className="hero-sub">{admin ? t("heroAdminSub") : t("heroBookSub")}</p>

        <ul className="hero-meta">
          <li>
            <span className="meta-k">{t("metaWindow")}</span>
            <span className="meta-v">02:00 – 18:00</span>
          </li>
          <li>
            <span className="meta-k">{t("metaTz")}</span>
            <span className="meta-v">America/São Paulo</span>
          </li>
          <li>
            <span className="meta-k">{t("metaMeet")}</span>
            <span className="meta-v">Google Meet</span>
          </li>
        </ul>
      </div>
      <div className="hero-foot">Automatrix IA · {new Date().getFullYear()}</div>
    </aside>
  );
}

export function App({
  admin = false,
  children,
}: {
  admin?: boolean;
  children: ReactNode;
}) {
  return (
    <div className="app">
      <Hero admin={admin} />
      <main className="stage">
        <div className="stage-top">
          <LangSwitch />
        </div>
        <div className="stage-body">{children}</div>
      </main>
    </div>
  );
}
